import { render } from "./pwa-menu-share-icon.vue.js?vue&type=template&id=403ac40e!=!../../../../node_modules/vue-loader/dist/index.js??ruleSet[0]!./pwa-menu-share-icon.vue?vue&type=template&id=403ac40e"
const script = {}

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__